export default {
  "Audio Compressor": "Audio Compressor",
  "HitPaw Online Audio Compressor": "HitPaw Online Audio Compressor",
  "Reduce audio file size online without quality loss.": "Reduce audio file size online without quality loss.",
  "Compress": "Compress",
  "Compressing": "Compressing",
  "Compressed Successfully": "Compressed Successfully",
  "Compress New": "Compress New",
  "Compression is complete": "Compression is complete",
  "Compression failed": "Compression failed",
  "Quality": "Quality",
  "Format": "Format",
  "Add file": "Add file",
  "Output Settings": "Output Settings",
  
};
